import React, { useEffect, useRef } from "react";

import {
    lowDim,
    width,
    StyledKeyboard,
    StyledOctave,
} from "./styles";
import WhiteButton from "./WhiteButton";
import { getSelectedNote, getHintNote } from "./utils";
import { IProps, IOctaveProps } from "./interfaces";
import { IBar } from "../../../../../../common/types";
import { getAccidentals } from "../../../../Score/score-display/utils";

const Keyboard = (props: IProps) => {
    const keyboard = useRef<HTMLDivElement>(null);
    const scrollToView = () => {
        const { min, max, isLow, editor } = props;
        if (editor) {
            if (typeof keyboard.current!.scrollTo === "function") {
                keyboard.current!.scrollTo(400, 0);
            } else {
                keyboard.current!.scrollLeft = 400;
            }
            return;
        }
        let average = (min + max + 1) / 2;
        let screenWidth = isLow ? 680 : 1280;
        let scrollLeft = width * (isLow ? lowDim : 1) * (7 / 12) * (average - 36) - screenWidth / 2;
        if (typeof keyboard.current!.scrollTo === "function") {
            keyboard.current!.scrollTo(scrollLeft, 0);
        } else {
            keyboard.current!.scrollLeft = scrollLeft;
        }
    };
    useEffect(() => {
        scrollToView();
    }, [props.min, props.max])
    const {
        handleInput,
        min,
        max,
        isLow,
        selectedNote,
        score,
        activeVoice = 0,
        withSolfa,
    } = props;
    const noteObject = selectedNote
        ? (score["bars" + (activeVoice || "")] as IBar[])[selectedNote.bar]?.notes?.[selectedNote.note] || null
        : null;
    const accidentals = getAccidentals(score);
    const notes =
        selectedNote && noteObject?.p
            ? getSelectedNote(noteObject.p, accidentals[selectedNote.bar], score["octave" + (activeVoice || "0")] || 0)
            : [];
    const hintNote = getHintNote(props);
    const doOctave = score["octave" + (activeVoice || "0")] || 0;
    const forwardProps = {
        notes,
        min,
        max,
        isLow,
        click: handleInput,
        hintNote,
        withSolfa,
        doOctave,
        doPos: score.doPos,
    };
    return (
        <StyledKeyboard ref={keyboard} isLow={isLow}>
            <Octave index={36} octave={0} {...forwardProps} />
            <Octave index={48} octave={1} {...forwardProps} />
            <Octave index={60} octave={2} {...forwardProps} />
            <Octave index={72} octave={3} {...forwardProps} />
            <WhiteButton index={84} octave={4} {...forwardProps} />
        </StyledKeyboard>
    );
}

const Octave = ({
    index,
    click,
    min,
    max,
    octave,
    doOctave,
    doPos,
    isLow,
    notes,
    hintNote,
    withSolfa,
}: IOctaveProps) => {
    const props = {
        isLow,
        octave,
        click,
        min,
        max,
        notes,
        hintNote,
        withSolfa,
        doOctave,
        doPos,
    };
    return (
        <StyledOctave>
            <WhiteButton {...props} withBlack left index={index} />
            <WhiteButton {...props} withBlack right index={index + 2} />
            <WhiteButton {...props} index={index + 4} />
            <WhiteButton {...props} withBlack left index={index + 5} />
            <WhiteButton {...props} withBlack index={index + 7} />
            <WhiteButton {...props} withBlack right index={index + 9} />
            <WhiteButton {...props} index={index + 11} />
        </StyledOctave>
    );
};

export default Keyboard;
